import { Component,OnInit,OnDestroy,AfterViewInit } from '@angular/core';
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile } from "rxjs/operators";

@Component({
    templateUrl: './dtg.config.system.component.html'
})
export class DtgConfigSystemComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    subtitle: string;

    constructor(
        private modalService: NgbModal
    ) {

    }

    ngOnInit() {
        
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {}
}